import React, { RefObject, useEffect } from "react";
import './Common.css';
import { DrumTime } from "../../../audio/instruments/TR808Drum";
import { RydDial } from "../../widgets/data-input/RydDial";

interface GaugeControlProps {
    label: string;
    disabled?: boolean;
    update?: (value: number) => void;
    min?: number;
    max?: number;
    value?: number;
}

export const GaugeControl: React.FC<GaugeControlProps> = ({
    label,
    disabled = false,
    update,
    min = 0,
    max = 100,
    value
}) => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            // margin: '2px',
            marginBottom: '1px',
            borderRadius: '2px',
        }}
            className="ryd-gauge-control-panel">
            <label style={{fontSize: '0.7em',}}>{label}</label>
            {/* <input type="range" min="0" max="100" style={{ width: '50px' }} disabled={disabled} /> */}
            <RydDial initialValue={value} min={min} max={max} update={update}/>
        </div>
    );
};

function triggerActiveStyle(padRef: RefObject<HTMLDivElement| null>) {
    if (!padRef?.current) return;
    padRef.current.style.backgroundColor = 'red';

}

function triggerInactiveStyle(padRef: RefObject<HTMLDivElement| null>) {
    if (!padRef?.current) return;
    padRef.current.style.backgroundColor = 'lightgray';
}

export function TriggerPad({
    trigger
}: {
    trigger? : (time?: DrumTime) => void
}) {
    const padRef = React.useRef<HTMLDivElement>(null);
    return (<div
        ref={padRef}
        onMouseDown={() => {
            triggerActiveStyle(padRef);
            trigger?.();
        }}
        onMouseUp={() => {
            triggerInactiveStyle(padRef);
        }}
        className="ryd--trigger-pad"
    >
        {/* {name} */}
    </div>);
};

export type PadHighlightControllerCallbackSetter = (attackTriggered: any, releaseTriggered: any) => void;

